const normalizeNumber = (value, fallback = 0) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
};

const normalizeQuantity = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) {
    return 1;
  }
  return num;
};

const roundCurrency = (value) => Math.round((value + Number.EPSILON) * 100) / 100;

export const calculateLineItemTotals = ({ price, fee, quantity }) => {
  const normalizedPrice = normalizeNumber(price);
  const normalizedFee = normalizeNumber(fee);
  const normalizedQuantity = normalizeQuantity(quantity);

  const markup = roundCurrency((normalizedPrice * normalizedFee) / 100);
  const total = roundCurrency((normalizedPrice + markup) * normalizedQuantity);

  return {
    price: normalizedPrice,
    fee: normalizedFee,
    quantity: normalizedQuantity,
    markup,
    total,
  };
};
